<template>
  <v-overlay v-model="centerLoading" :scrim="false" class="custom_centered_overlay">
    <v-progress-circular color="green" indeterminate size="64"></v-progress-circular>
  </v-overlay>
  <v-app id="app_lead_list">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">REJECTED NEW VISITS</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Review all rejected new visit request data.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-card class="custom_card_box mt-8" elevation="1" border="sm opacity-1" rounded="lg" style="border-radius: 2px !important;">
        <v-card-text class="custom_tool_bar_style">
          <v-btn class=" custom_pdf_btn" variant="outlined" @click="exportPDF" style="border-radius: 2px !important;">
            <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
          </v-btn>
          <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="exportExcel" style="border-radius: 2px !important;">
            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
          </v-btn>
        </v-card-text>
        <v-divider thickness="2"></v-divider>
        <v-card-text>
          <v-row class="mt-0">
            <v-col cols="12" md="3">
              <v-date-input v-model="assignDate" @click:append-inner="clearAssignDate" append-inner-icon="mdi-close"
                            label="Assign Date" prepend-inner-icon="$calendar" multiple="range"
                            prepend-icon="" placeholder="Select a Date Range" variant="outlined" density="comfortable"
                            class="custom_input_field_color"
              ></v-date-input>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.salesRep"
                :items="salesRepList"
                label="Sales Rep"
                placeholder="Select Rep"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                multiple
                clearable
                @update:model-value="applyFilters"
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip v-bind="props" color="#e7e7e7" variant="flat" class="text-black font-weight-medium" size="small" closable style="border-radius: 2px !important;">
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filters.areaCode"
                :items="areaList"
                label="Area"
                placeholder="Select Area"
                variant="outlined"
                density="comfortable"
                class="custom_input_field_color"
                multiple
                clearable
                @update:model-value="applyFilters"
              >
                <template v-slot:chip="{ props, item }">
                  <v-chip v-bind="props" color="#e7e7e7" variant="flat" class="text-black font-weight-medium" size="small" closable style="border-radius: 2px !important;">
                    {{ item.title }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="tableSearch"
                append-inner-icon="mdi-magnify"
                density="comfortable"
                class="custom_input_field_color"
                clearable
                label="Search Data"
                placeholder="Search Data"
                variant="outlined"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-data-table v-model:page="page" :headers="headers" :items="filteredItems" :items-per-page="itemsPerPage"
                        :loading="loading" class="custom_table_normal"
                        item-key="id" item-value="id"
          >
            <template v-slot:[`item.salesRep_name`]="{ item }">
              <div>{{ item.salesRep_name }}</div>
            </template>
            <template v-slot:[`item.visited_status_clean`]="{ item }">
              <v-chip v-if="item.visited_status_clean?.toUpperCase() === 'VISITED'" class="chip-visited" size="small" variant="flat" style="border-radius: 50px !important;">
                <span class="font-weight-bold text-black">{{ item.visited_status_clean?.toUpperCase() }}</span>
                <v-icon size="small" color="black" class="ml-1">mdi-check</v-icon>
              </v-chip>
              <v-chip v-else-if="item.visited_status_clean?.toUpperCase() === 'PENDING'" class="chip-pending" size="small" variant="flat" style="border-radius: 50px !important;">
                <span class="font-weight-bold text-black">{{ item.visited_status_clean?.toUpperCase() }}</span>
                <v-icon size="small" color="black" class="ml-1">mdi-clock-outline</v-icon>
              </v-chip>
              <v-chip v-else class="chip-not-visited" size="small" variant="flat" style="border-radius: 50px !important;">
                <span class="font-weight-bold text-black">{{ item.visited_status_clean?.toUpperCase() || 'NOT VISITED' }}</span>
                <v-icon size="small" color="black" class="ml-1">mdi-close</v-icon>
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-menu transition="slide-x-transition" id="app_product_list">
                <template v-slot:activator="{ props }">
                  <v-btn 
                    style="background-color: #800080; color: white; border-radius: 2px !important;" 
                    variant="flat" 
                    size="large" 
                    v-bind="props">
                    ACTIONS &nbsp; &nbsp;
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item v-if="permissions.read" @click="viewItem(item)">
                    <v-list-item-title class="custom_font_color_view">VIEW</v-list-item-title>
                  </v-list-item>

                  <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                    <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-dialog v-model="view_leads_dialog" fullscreen id="app_lead_list">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;" class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')" @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="custom_purple_btn" variant="flat" color="#800080" style="border-radius: 2px !important; color: white;" @click="view_leads_dialog = false">CLOSE</v-btn>
          </v-toolbar>
          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1" style="border-radius: 2px !important;">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">REJECTED NEW VISITS DETAILS</v-card-title>
                </template>
              </v-card>
              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1" v-if="selectedLead" style="border-radius: 2px !important;">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="4" md="9" lg="9">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="3" lg="2" xl="2">
                        <v-img :src="UserResponseData.user_image ? `${imageURL}/${UserResponseData.user_image}` : require('@/assets/ASSETS/PERSONS/person-3.jpg')" aspect-ratio="1" class="user_image_view"></v-img>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="9" lg="10" xl="10">
                        <div class="d-flex">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">User Name: &nbsp;</p>
                          <p class="font-weight-bold custom_page_component_main_title" style="color: #05146F !important;">{{ selectedLead.salesRep_name }}</p>
                        </div>
                        <div class="d-flex mt-1">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">Mobile: &nbsp;</p>
                          <p class="font-weight-medium text-body-2 custom_page_component_main_title mt-1">{{ selectedLead.mobile_number }}</p>
                        </div>
                        <div class="d-flex mt-6">
                          <v-chip v-if="selectedLead.lead_status && selectedLead.lead_status.toUpperCase() === 'VISITED'" class="chip-visited" size="small" variant="flat" style="border-radius: 50px !important;">
                            <span class="font-weight-bold text-black">{{ selectedLead.lead_status.toUpperCase() }}</span>
                            <v-icon size="small" color="black" class="ml-1">mdi-check</v-icon>
                          </v-chip>
                          <v-chip v-else-if="selectedLead.lead_status && selectedLead.lead_status.toUpperCase() === 'PENDING'" class="chip-pending" size="small" variant="flat" style="border-radius: 50px !important;">
                            <span class="font-weight-bold text-black">{{ selectedLead.lead_status.toUpperCase() }}</span>
                            <v-icon size="small" color="black" class="ml-1">mdi-clock-outline</v-icon>
                          </v-chip>
                          <v-chip v-else class="chip-not-visited" size="small" variant="flat" style="border-radius: 50px !important;">
                            <span class="font-weight-bold text-black">{{ selectedLead.lead_status ? selectedLead.lead_status.toUpperCase() : 'NOT COMPLETED' }}</span>
                            <v-icon size="small" color="black" class="ml-1">mdi-close</v-icon>
                          </v-chip>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                      <v-btn v-if="permissions.delete" class="custom_delete_btn" icon rounded size="small" variant="outlined" @click="confirmDelete(selectedLead)" style="border-radius: 2px !important;">
                        <v-icon>mdi-trash-can</v-icon>
                        <v-tooltip activator="parent" location="top">Delete</v-tooltip>
                      </v-btn>
                    </v-row>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-text-field v-model="selectedLead.lead_title" class="px-3 custom_input_field_class_view custom_input_field_color" label="New Visit Title" placeholder="Type title here" readonly variant="outlined" density="comfortable"></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-text-field v-model="selectedLead.area_code" density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color" label="Area" readonly variant="outlined"></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-text-field v-model="selectedLead.assign_date" density="comfortable" class="px-3 custom_input_field_class_view custom_input_field_color" label="Assign Date" readonly variant="outlined"></v-text-field>
                  </v-col>
                  
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <div class="px-3 mb-4">
                      <p class="custom_page_main_sub_title">New Visit Description</p>
                      <v-divider class="mt-3 mb-4"></v-divider>
                      <v-card color="#F7F7F7" flat border="sm opacity-1" outlined density="comfortable" style="border-radius: 2px !important;">
                        <v-card-text>
                          <div v-html="getSanitizedHTML(selectedLead.discription)" class="ml-3 ql-container ql-snow"></div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-col>
                  
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <div class="px-3 mb-4">
                      <p class="custom_page_main_sub_title" style="color: #BB0000;">Reject Reason</p>
                      <v-divider class="mt-3 mb-4"></v-divider>
                      <v-card color="#FFF5F5" flat border="sm opacity-1" outlined density="comfortable" style="border-radius: 2px !important; border-color: #ffcccc !important;">
                        <v-card-text>
                          <div class="ml-3 text-body-1 font-weight-medium" style="color: #BB0000;">
                            {{ selectedLead.approval_reason || 'No specific reject reason provided.' }}
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="px-3">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider class="mt-1 mb-3"></v-divider>
                    <p class="custom_page_main_sub_title"><strong>SELECTED NEW VISITS LIST</strong></p>
                    <p class="custom_page_main_sub_title mt-2" style="opacity: 0.6">The following table shows all the institutes related to the above-defined new visit.</p>
                    <v-card class="mt-4 mb-4 custom_card_box" elevation="1" border="sm opacity-1" rounded="lg" style="border-radius: 2px !important;">
                      <v-card-text>
                        <v-data-table :headers="headers_two" :items="selectedLead.selected_leads || []" :items-per-page="-1" hide-default-footer density="default" class="custom_table_normal">
                          <template v-slot:[`item.institute_name`]="{ item }">
                            <span>{{ item.institute_name }}</span>
                          </template>
                          <template v-slot:[`item.visited_status`]="{ item }">
                            <v-chip v-if="item.visited_status && item.visited_status.toUpperCase() === 'VISITED'" class="chip-visited" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold text-black">{{ item.visited_status.toUpperCase() }}</span>
                              <v-icon size="small" color="black" class="ml-1">mdi-check</v-icon>
                            </v-chip>
                            <v-chip v-else-if="item.visited_status && item.visited_status.toUpperCase() === 'PENDING'" class="chip-pending" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold text-black">{{ item.visited_status.toUpperCase() }}</span>
                              <v-icon size="small" color="black" class="ml-1">mdi-clock-outline</v-icon>
                            </v-chip>
                            <v-chip v-else class="chip-not-visited" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold text-black">{{ item.visited_status ? item.visited_status.toUpperCase() : 'NOT VISITED' }}</span>
                              <v-icon size="small" color="black" class="ml-1">mdi-close</v-icon>
                            </v-chip>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-dialog v-model="edit_leads_dialog" fullscreen id="app_lead_list">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;" class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')" @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn variant="flat" style="background-color: #800080 !important; color: #ffffff !important; border-radius: 2px !important;" @click="edit_leads_dialog = false">CLOSE</v-btn>
          </v-toolbar>
          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1" style="border-radius: 2px !important;">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">UPDATE LEAD DETAILS</v-card-title>
                </template>
              </v-card>
              <v-card class="pa-3 mx-6 custom_card_box mt-4" border="sm opacity-1" style="border-radius: 2px !important;">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="4" md="9" lg="9">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="3" lg="2" xl="2">
                        <v-img :src="UserResponseData.user_image ? `${imageURL}/${UserResponseData.user_image}` : require('@/assets/ASSETS/PERSONS/person-3.jpg')" aspect-ratio="1" class="user_image_view"></v-img>
                      </v-col>
                      <v-col cols="12" xs="12" sm="12" md="9" lg="10" xl="10">
                        <div class="d-flex">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">User Name: &nbsp;</p>
                          <p class="font-weight-bold custom_page_component_main_title" style="color: #05146F !important;">{{ selectedLead.salesRep_name }}</p>
                        </div>
                        <div class="d-flex mt-1">
                          <p class="font-weight-bold custom_page_component_main_title text-body-1">Mobile: &nbsp;</p>
                          <p class="font-weight-medium text-body-2 custom_page_component_main_title mt-1">{{ selectedLead.mobile_number }}</p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                      <v-btn variant="flat" size="large" style="background-color: #800080 !important; color: #ffffff !important; border-radius: 2px !important;" @click="updateLead()">UPDATE LEAD</v-btn>
                    </v-row>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-text-field v-model="selectedLead.lead_title" :disabled="selectedLead.visited_status === 'VISITED'" class="px-3 custom_input_field_color" label="New Visit Title *" placeholder="Type title here" variant="outlined" density="comfortable"></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-autocomplete v-model="selectedLead.lead_main_category" :disabled="true" :items="categories" :loading="mainFilterLoading" density="comfortable" class="px-3 custom_input_field_color" label="Main Category *" readonly variant="outlined" item-text="main_filter" item-value="id" @update:modelValue="fetchSubCategories(selectedLead.lead_main_category)"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4" lg="4">
                    <v-autocomplete v-model="selectedLead.lead_sub_category" :disabled="true" :items="subCategories" :loading="subFilterLoading" density="comfortable" class="px-3 custom_input_field_color" label="Sub Category *" readonly variant="outlined" item-text="sub_filter" item-value="id"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-autocomplete v-model="selectedLead.province" :disabled="true" :items="provinces" :loading="mDistrictLoading" item-text="label" item-value="value" label="Province *" placeholder="Select province" readonly variant="outlined" density="comfortable" @update:modelValue="getAllDistrictAccProv" class="mt-2 px-3 custom_input_field_color"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-autocomplete class="mt-2 px-3 custom_input_field_color" density="comfortable" v-model="selectedLead.agent_name" :disabled="selectedLead.visited_status === 'VISITED'" :items="agentProvinceWise" item-title="name" item-value="name" label="Assign Agent *" placeholder="Select agent" variant="outlined"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-autocomplete v-model="selectedLead.district" :disabled="isDisabledDistrictList" :items="districts" :loading="mDistrictLoading" item-text="label" item-value="value" label="District" placeholder="Select district" density="comfortable" readonly variant="outlined" @update:modelValue="getAllDsd" class="mt-2 px-3 custom_input_field_color"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-autocomplete v-model="selectedLead.dsd" :disabled="isDisabledDSDLIST" :items="dsdList" :loading="mDSDLoading" item-text="label" item-value="value" label="DSD" placeholder="Select divisional" readonly density="comfortable" variant="outlined" @update:modelValue="getAllGnd" class="mt-2 px-3 custom_input_field_color"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-autocomplete v-model="selectedLead.gnd" :disabled="isDisabledGNDList" :items="gndList" :loading="mDSDLoading" label="GND" placeholder="Select GND" readonly variant="outlined" class="mt-2 px-3 custom_input_field_class_view custom_input_field_color" density="comfortable"></v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3" lg="3">
                    <v-date-input v-model="assignDateObject" :disabled="selectedLead.visited_status === 'VISITED'" label="Assign Date *" persistent-placeholder variant="outlined" density="comfortable" class="px-3 custom_input_field_color" prepend-icon="" prepend-inner-icon="$calendar"></v-date-input>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-row class="px-3">
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <p class="custom_page_main_sub_title" style="opacity: 0.6">Type Description </p>
                        <v-divider class="mt-4 mb-3"></v-divider>
                        <v-card class="mt-5" elevation="1" border="sm opacity-1" rounded="lg" max-height="355" min-height="355" style="border-radius: 2px !important;">
                          <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode"/>
                          <v-divider></v-divider>
                          <Editor v-model="selectedLead.lead_description" :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated"/>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="px-3">
                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider class="mt-1 mb-3"></v-divider>
                    <p class="custom_page_main_sub_title"><strong>RELATED LEADS LIST</strong></p>
                    <p class="custom_page_main_sub_title mt-2" style="opacity: 0.6">The following table shows all the outlets/institutes related to the above-defined lead.</p>
                    <v-card class="mt-4 mb-4 custom_card_box" elevation="1" border="sm opacity-1" rounded="lg" style="border-radius: 2px !important;">
                      <v-card-text>
                        <v-data-table :headers="headers_two" :items="selectedLead.selected_leads || []" :items-per-page="-1" hide-default-footer density="default" class="custom_table_normal">
                          <template v-slot:[`item.institute_name`]="{ item }">
                            <span>{{ item.institute_name }}</span>
                          </template>
                          <template v-slot:[`item.visited_status`]="{ item }">
                            <v-chip v-if="item.visited_status && item.visited_status.toUpperCase() === 'VISITED'" class="chip-visited" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold text-black">{{ item.visited_status.toUpperCase() }}</span>
                              <v-icon size="small" color="black" class="ml-1">mdi-check</v-icon>
                            </v-chip>
                            <v-chip v-else-if="item.visited_status && item.visited_status.toUpperCase() === 'PENDING'" class="chip-pending" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold text-black">{{ item.visited_status.toUpperCase() }}</span>
                              <v-icon size="small" color="black" class="ml-1">mdi-clock-outline</v-icon>
                            </v-chip>
                            <v-chip v-else class="chip-not-visited" size="small" variant="flat" style="border-radius: 50px !important;">
                              <span class="font-weight-bold text-black">{{ item.visited_status ? item.visited_status.toUpperCase() : 'NOT VISITED' }}</span>
                              <v-icon size="small" color="black" class="ml-1">mdi-close</v-icon>
                            </v-chip>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-dialog v-model="deleteLeadDialog" id="app_lead_list" max-height="500" max-width="500" persistent @update:model-value="resetDialogState">
        <v-card rounded="md" style="border-radius: 2px !important;">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE NEW VISIT</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="deleteLeadDialog = false; resetDialogState()" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>
            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>&nbsp;&nbsp;Do you want to delete this New Visit?
                </v-card-title>
                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  <span v-if="visited_count > 0">This new visit cannot be deleted because it has {{ visited_count }} associated data in the following tables. Please remove the associations first.</span>
                  <span v-else>This new visit will be deleted immediately. Once deleted, it can no longer be used for any purpose.</span>
                </p>
                <v-divider class="mt-4"></v-divider>
                <div v-if="visited_count > 0">
                  <div class="text-body-2 mt-4 text-justify"><strong>New Visited Count:</strong> {{ visited_count }}</div>
                  <div class="text-body-2 text-justify"><strong>New Visit Agent:</strong> {{ agent_name }} / {{ reg_num }}</div>
                  <div class="text-body-2 text-justify"><strong>New Visit Assign Date:</strong> {{ assign_date }}</div>
                  <div class="text-body-2 text-justify"><strong>New Visit ID:</strong> {{ LeadID }}</div>
                </div>
                <v-timeline align="start" density="compact">
                  <v-timeline-item v-for="(lead) in salesLeadList" :key="lead.id" dot-color="#05146F">
                    <template v-slot:opposite></template>
                    <div>
                      <p><strong>Lead ID:</strong> {{ lead.id }}</p>
                      <p><strong>Lead Institute Name:</strong> {{ lead.institute_name }}</p>
                      <p><strong>Lead Sub Category:</strong> {{ lead.sub_category }}</p>
                      <p><strong>Lead Date:</strong> {{ formatDate(lead.created_at) }}</p>
                    </div>
                  </v-timeline-item>
                </v-timeline>
                <v-divider class="mt-4"></v-divider>
                <div class="float-end mt-4">
                  <v-btn color="red" @click="deleteItem" :disabled="salesLeadList.length > 0" style="border-radius: 2px !important;">
                    DELETE
                  </v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="deleteLeadDialog = false ; resetDialogState()" style="border-radius: 2px !important;">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" location="top right" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from "xlsx";
import { getPermissions } from "@/plugins/permissions";
import DOMPurify from 'dompurify';
import '@wangeditor/editor/dist/css/style.css';
import { i18nChangeLanguage } from '@wangeditor/editor';
i18nChangeLanguage('en');
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue';

export default {
  components: { Editor, Toolbar },

  setup() {
    const editorRef = shallowRef();
    const valueHtml = ref('<p></p>');
    onMounted(() => {
      setTimeout(() => { valueHtml.value = '<p></p>'; }, 1500);
    });
    const toolbarConfig = { toolbarKeys: ['bold', 'italic', 'underline', 'through'] };
    const editorConfig = { placeholder: 'Type here...' };
    onBeforeUnmount(() => {
      if (editorRef.value) editorRef.value.destroy();
    });
    const handleCreated = (editor) => { editorRef.value = editor; };
    return { editorRef, mode: 'simple', valueHtml, toolbarConfig, editorConfig, handleCreated };
  },

  name: 'RejectedLeadsList',

  data() {
    return {
      salesLeadList: [],
      visited_count: 0,
      agent_name: '',
      reg_num: '',
      LeadID: '',
      assign_date: '',
      reminderMessage: '',
      UserResponseData: { email: '', mobile_number: '', mobile: '', user_image: '' },
      imageURL: "",
      centerLoading: false,
      tab: null,
      headers: [
        { title: 'NEW VISIT TITLE', key: 'lead_title', value: 'lead_title', sortable: true },
        { title: 'AREA', key: 'area_code', value: 'area_code', sortable: true },
        { title: 'ADDRESS', key: 'address', value: 'address', sortable: true },
        { title: 'SALES REP NAME', key: 'salesRep_name', value: 'salesRep_name', sortable: true },
        { title: 'ASSIGN DATE', key: 'assign_date', value: 'assign_date', sortable: true },
        { title: 'VISITED STATUS', key: 'visited_status_clean', value: 'visited_status_clean', sortable: true },
        { title: 'ACTION', key: 'actions', value: 'actions', sortable: false }
      ],
      items: [],
      totalItems: 0,
      page: 1,
      itemsPerPage: 10,
      filters: { salesRep: [], areaCode: [] },
      salesRepList: [],
      areaList: [],
      view_leads_dialog: false,
      edit_leads_dialog: false,
      assignDateObject: new Date(),
      deleteLeadDialog: false,
      reminderDialog: false,
      reminderDialogNew: false,
      selectedItem: {},
      assignDate: null,
      tableSearch: '',
      selectedLead: null,
      selectedLeadId: null,
      notVisitedOutletItem: [],
      selectedItems: [],
      selectAllOutlet: false,
      snackAlert: { snackbar: false, snackColor: "", snackMessage: "" },
      mainFilterLoading: false,
      subFilterLoading: false,
      mDistrictLoading: false,
      mDSDLoading: false,
      mGNDLoading: false,
      provinces: [],
      districts: [],
      dsdList: [],
      gndList: [],
      isDisabledProvinceList: false,
      isDisabledDistrictList: false,
      isDisabledDSDLIST: false,
      isDisabledGNDList: false,
      agents: [],
      agentProvinceWise: [],
      categories: [],
      subCategories: [],
      allCategories: [],
      permissions: {},
      headers_two: [
        { title: 'INSTITUTE NAME', key: 'institute_name', sortable: true },
        { title: 'ADDRESS', key: 'address', sortable: true },
        { title: 'VISITED STATUS', key: 'visited_status', sortable: true }
      ],
      loading: false
    };
  },

  computed: {
    filteredItems() {
      if (!this.items || this.items.length === 0) return [];
      
      const selectedDateRange = this.getSelectedDateRange();
      
      let filtered = this.items.filter((item) => {
        let matchesDate = true;
        if (selectedDateRange) {
          const itemDate = this.formatDateForComparison(item.assign_date);
          matchesDate = !!itemDate && itemDate >= selectedDateRange.start && itemDate <= selectedDateRange.end;
        }
        
        let matchesSalesRep = true;
        if (this.filters.salesRep && this.filters.salesRep.length) {
          matchesSalesRep = this.filters.salesRep.includes(item.salesRep_name);
        }
        
        let matchesArea = true;
        if (this.filters.areaCode && this.filters.areaCode.length) {
          matchesArea = this.filters.areaCode.includes(item.area_code);
        }
        
        return matchesDate && matchesSalesRep && matchesArea;
      });
      
      if (this.tableSearch) {
        const searchTerm = this.tableSearch.toLowerCase();
        filtered = filtered.filter(item => {
          return (
            (item.lead_title && item.lead_title.toLowerCase().includes(searchTerm)) ||
            (item.area_code && item.area_code.toLowerCase().includes(searchTerm)) ||
            (item.address && item.address.toLowerCase().includes(searchTerm)) ||
            (item.salesRep_name && item.salesRep_name.toLowerCase().includes(searchTerm)) ||
            (item.lead_status && item.lead_status.toLowerCase().includes(searchTerm))
          );
        });
      }
      
      return filtered;
    }
  },

  created() {
    this.fetchAreaList();
    this.fetchDataintoTable();
    this.imageURL = process.env.VUE_APP_IMAGE_PUBLIC_URL;
  },

  mounted() {
    const dashboardId = 3;
    this.permissions = getPermissions(dashboardId);
  },

  methods: {
    getMobileNumber(leadData) {
      if (leadData.sales_rep_mobile && leadData.sales_rep_mobile.mobile_number) {
        const countryCode = leadData.sales_rep_mobile.country_code || '';
        const mobileNumber = leadData.sales_rep_mobile.mobile_number || '';
        return countryCode ? `${countryCode} ${mobileNumber}` : mobileNumber;
      }
      
      if (leadData.mobile_number && leadData.mobile_number !== 'N/A' && leadData.mobile_number !== '') {
        return leadData.mobile_number;
      }

      if (this.UserResponseData && this.UserResponseData.mobile_number) {
        return this.UserResponseData.mobile_number;
      }
      
      if (this.UserResponseData && this.UserResponseData.mobile) {
        return this.UserResponseData.mobile;
      }
      
      return 'N/A';
    },

    fetchAreaList() {
      const token = localStorage.getItem("token");
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/area-allList`, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).then(response => {
        if (response.data && response.data.success) {
          this.areaList = response.data.data.map(area => ({
            title: `${area.area_code} | ${area.description}`,
            value: area.area_code 
          }));
        }
      }).catch(error => {
        console.error("Error fetching areas", error);
      });
    },

    formatDateForComparison(date) {
      if (!date) return null;

      if (typeof date === 'string') {
        const trimmedDate = date.trim();
        const dateOnlyMatch = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (dateOnlyMatch) return `${dateOnlyMatch[1]}-${dateOnlyMatch[2]}-${dateOnlyMatch[3]}`;

        const isoDateMatch = trimmedDate.match(/^(\d{4})-(\d{2})-(\d{2})T/);
        if (isoDateMatch) return `${isoDateMatch[1]}-${isoDateMatch[2]}-${isoDateMatch[3]}`;
      }

      const parsedDate = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(parsedDate.getTime())) return null;

      const year = parsedDate.getFullYear();
      const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
      const day = String(parsedDate.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    getSelectedDateRange() {
      if (!this.assignDate) return null;

      const selectedValues = (Array.isArray(this.assignDate) ? this.assignDate : [this.assignDate])
        .filter(Boolean)
        .map((date) => this.formatDateForComparison(date))
        .filter(Boolean);

      if (selectedValues.length === 0) return null;

      selectedValues.sort();

      return {
        start: selectedValues[0],
        end: selectedValues[selectedValues.length - 1]
      };
    },

    clearAssignDate() {
      this.assignDate = null;
    },

    applyFilters() {
      this.filteredItems = [...this.filteredItems];
    },

    cleanText(text) {
      if (!text) return '';
      let str = String(text).replace(/[_,\\-]/g, ' ').replace(/\s+/g, ' ').trim();
      let formatted = str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
      if (formatted === 'Not Complete') return 'Not Completed';
      return formatted;
    },

    toggleSelectAllOutletItem() {
      if (this.selectAllOutlet) {
        this.selectedItems = this.notVisitedOutletItem.map(item => item.id);
      } else {
        this.selectedItems = [];
      }
    },

    getSanitizedHTML(html) {
      if(!html) return "";
      return DOMPurify.sanitize(html);
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    fetchDataintoTable() {
      const token = localStorage.getItem("token");
      
      let rawUserId = localStorage.getItem("userId");
      const userId = (rawUserId && rawUserId !== 'null' && rawUserId !== 'undefined') ? rawUserId : 1; 

      this.loading = true;

      let url = `${process.env.VUE_APP_API_BASE_URL}/api/v1-selected-leads?approval_status=REJECT&userId=${userId}&page=1&size=100000`;

      axios.get(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      }).then((response) => {
        if (response.data && response.data.success) {
          let fetchedData = response.data.data || [];
          
          // Sort the array by id in descending order so newest items appear first
          fetchedData.sort((a, b) => (b.id || 0) - (a.id || 0));
          
          this.items = fetchedData.map(lead => {
            const cleanedVisitedStatus = this.cleanText(lead.visited_status || 'Pending');
            const cleanedLeadStatus = this.cleanText(lead.lead_status || 'Not Completed');
            
            let mobileNum = 'N/A';
            if (lead.sales_rep_mobile && lead.sales_rep_mobile.mobile_number) {
              mobileNum = lead.sales_rep_mobile.country_code 
                ? `${lead.sales_rep_mobile.country_code} ${lead.sales_rep_mobile.mobile_number}` 
                : lead.sales_rep_mobile.mobile_number;
            } else if (lead.mobile_number) {
              mobileNum = lead.mobile_number;
            }
            
            return {
              ...lead,
              address: lead.address || '',
              salesRep_name: lead.salesRep_name || lead.sales_rep_name || 'N/A',
              reg_num: lead.assign_saleRep || lead.reg_num || 'N/A',
              area_code: lead.area_code || '',
              assign_date: lead.assign_date ? lead.assign_date.split('T')[0] : '',
              visited_status_clean: cleanedVisitedStatus,
              selected_leads: [{
                institute_name: lead.institute_name,
                address: lead.address,
                visited_status: cleanedVisitedStatus
              }],
              lead_status: cleanedLeadStatus,
              mobile_number: mobileNum,
              agent_email: lead.agent_email || ''
            };
          });
          
          this.totalItems = response.data.total || 0;

          this.salesRepList = [...new Set(this.items.map(item => item.salesRep_name).filter(Boolean))]
            .map(name => ({ title: name, value: name }));

        } else {
          this.items = [];
          this.totalItems = 0;
        }
        this.loading = false;
      }).catch((error) => {
        console.error("API Fetch Error:", error);
        this.items = [];
        this.totalItems = 0;
        this.loading = false;
      });
    },

    async viewItem(item) {
      this.centerLoading = true;
      this.selectedLead = { 
        ...item,
        mobile_number: item.mobile_number || 'N/A'
      };
      
      this.notVisitedOutletItem = item.selected_leads ? item.selected_leads.filter(lead => lead.visited_status === "NOT VISITED") : [];
      this.view_leads_dialog = true;

      const token = localStorage.getItem('token');

      try {
        const registrationNum = item.reg_num || item.assign_saleRep;
        
        if (registrationNum) {
          try {
            const userResponse = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/user/${registrationNum}`, {
              headers: { 
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
            
            if (userResponse.data && userResponse.data.data) {
              this.UserResponseData = userResponse.data.data;
              
              if (this.selectedLead.mobile_number === 'N/A') {
                this.selectedLead.mobile_number = this.UserResponseData.mobile_number 
                  || this.UserResponseData.mobile 
                  || 'N/A';
              }
            }
          } catch (userError) {
            console.warn('Could not fetch user info:', userError.message);
          }
        }

        try {
          const leadResponse = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/v1/lead/${item.lead_id || item.id}`, {
            headers: { 
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          
          if (leadResponse.data && leadResponse.data.data) {
            const leadData = leadResponse.data.data;
            
            if (leadData.sales_rep_mobile && leadData.sales_rep_mobile.mobile_number) {
              const countryCode = leadData.sales_rep_mobile.country_code || '';
              const mobileNumber = leadData.sales_rep_mobile.mobile_number || '';
              this.selectedLead.mobile_number = countryCode ? `${countryCode} ${mobileNumber}` : mobileNumber;
            } else if (leadData.mobile_number) {
              this.selectedLead.mobile_number = leadData.mobile_number;
            }
            
            if (leadData.selected_leads && leadData.selected_leads.length > 0) {
              const matchedLeads = leadData.selected_leads.filter(l => l.institute_name === item.institute_name);
              this.selectedLead.selected_leads = matchedLeads.length > 0 ? matchedLeads : item.selected_leads;
              this.notVisitedOutletItem = this.selectedLead.selected_leads.filter(lead => lead.visited_status === "NOT VISITED");
            }
            
            if (leadData.discription) {
              this.selectedLead.discription = leadData.discription;
            }
          }
        } catch (leadError) {
          console.warn('Could not fetch lead details:', leadError.message);
        }
      } catch (error) {
        console.error('Error in viewItem:', error);
      } finally {
        this.centerLoading = false;
      }
    },

    async editItem(item) {
      this.centerLoading = true;
      this.selectedLead = { 
        ...item,
        mobile_number: item.mobile_number || 'N/A'
      };

      const token = localStorage.getItem('token');

      try {
        const registrationNum = item.reg_num || item.assign_saleRep;
        
        if (registrationNum) {
          try {
            const userResponse = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/user/${registrationNum}`, {
              headers: { 
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            });
            
            if (userResponse.data && userResponse.data.data) {
              this.UserResponseData = userResponse.data.data;
              
              if (this.selectedLead.mobile_number === 'N/A') {
                this.selectedLead.mobile_number = this.UserResponseData.mobile_number 
                  || this.UserResponseData.mobile 
                  || 'N/A';
              }
            }
          } catch (userError) {
            console.warn('Could not fetch user info:', userError.message);
          }
        }
      } catch (error) {
        console.error('Error in editItem:', error);
      } finally {
        this.centerLoading = false;
        this.edit_leads_dialog = true;
      }
    },

    async confirmDelete(item) {
      this.selectedLeadId = item.id;
      this.salesLeadList = [];
      this.visited_count = 0;
      
      this.deleteLeadDialog = true;

      try {
        const token = localStorage.getItem('token');
        const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/checkLeadAssociations/${this.selectedLeadId}`, {}, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        if(response.data.message === "No associated data found with visited_status VISITED.") {
          this.salesLeadList = [];
          this.visited_count = 0;
          this.agent_name = '';
          this.reg_num = '';
          this.LeadID = '';
          this.assign_date = '';
        } else if (response.data.associated_data?.selected_lead_list) {
          this.salesLeadList = response.data.associated_data.selected_lead_list;
          const leadDetails = response.data.associated_data.lead_details;
          this.visited_count = response.data.associated_data.visited_count;
          this.agent_name = leadDetails.agent_name || leadDetails.salesRep_name;
          this.reg_num = leadDetails.reg_num;
          this.LeadID = leadDetails.id;
          this.assign_date = leadDetails.assign_date;
        }
      } catch (error) {
        console.error("Error fetching lead associations:", error);
      }
    },

    resetDialogState() {
      this.salesLeadList = [];
      this.visited_count = 0;
      this.agent_name = '';
      this.reg_num = '';
      this.LeadID = '';
      this.assign_date = '';
    },

    deleteItem() {
      this.centerLoading = true;
      const token = localStorage.getItem('token');
      const leadId = this.selectedLeadId;
      
      let rawUserId = localStorage.getItem("userId");
      const userId = (rawUserId && rawUserId !== 'null' && rawUserId !== 'undefined') ? parseInt(rawUserId) : 1;
      
      axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/v1/selected-leads/${leadId}`, {
        headers: { 
          'Authorization': `Bearer ${token}`, 
          'Content-Type': 'application/json' 
        },
        data: {
          userId: userId
        }
      }).then(() => {
        this.items = this.items.filter(item => {
          const currentId = item.id;
          return currentId !== leadId;
        });
        
        this.totalItems = this.items.length;
        this.centerLoading = false;
        this.deleteLeadDialog = false;
        this.view_leads_dialog = false;
        this.edit_leads_dialog = false;
        this.showSnackbar("The New Visit Was Successfully Deleted", "success");
        
        this.fetchDataintoTable();
      }).catch((error) => {
        console.error('Error deleting new visit', error);
        this.centerLoading = false;
        this.deleteLeadDialog = false;
        this.showSnackbar("Failed to delete the new visit", "error");
      });
    },

    backPageRoute() {
      this.$router.back();
    },

    homeReload() {
      window.location.href = '/dashboard';
    },

    exportExcel() {
      const tableData = this.filteredItems.map((item, index) => ({
        'NO': index + 1,
        'NEW VISIT TITLE': item.lead_title,
        'AREA': item.area_code,
        'ADDRESS': item.address,
        'SALES REP NAME': item.salesRep_name,
        'ASSIGN DATE': item.assign_date,
        'VISITED STATUS': item.visited_status_clean
      }));
      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Rejected New Visits');
      XLSX.writeFile(workbook, 'rejected_new_visits.xlsx');
    },

    exportPDF() {
      const doc = new jsPDF();
      doc.setFontSize(18);
      doc.setFont("helvetica", "bold");
      doc.text('Rejected New Visits', 14, 10);
      const tableData = this.filteredItems.map((item, index) => [
        index + 1,
        item.lead_title,
        item.area_code,
        item.address,
        item.salesRep_name,
        item.assign_date,
        item.visited_status_clean
      ]);
      doc.autoTable({
        head: [['NO', 'NEW VISIT TITLE', 'AREA', 'ADDRESS', 'SALES REP NAME', 'ASSIGN DATE', 'VISITED STATUS']],
        body: tableData,
        startY: 35,
      });
      doc.save('rejected_new_visits.pdf');
    },

    updateLead() {
      this.showSnackbar("Lead data was updated successfully!", "success");
    },

    sendReminder() {
      this.showSnackbar("Reminder sent successfully.", "success");
      this.reminderDialog = false;
    },

    sendReminderNew() {
      this.showSnackbar("Reminder sent successfully.", "success");
      this.reminderDialogNew = false;
    },

    getAllDistrictAccProv(province) {
      console.log('Get districts for province:', province);
    },

    getAllDsd(district) {
      console.log('Get DSD for district:', district);
    },

    getAllGnd(dsd) {
      console.log('Get GND for DSD:', dsd);
    },

    fetchSubCategories(mainCategory) {
      console.log('Fetch sub categories for:', mainCategory);
    }
  }
};
</script>

<style lang="scss" scoped>
@use "../../styles/lead_management/leads_list.scss" as *;
.custom_font_color_view {
  color: #4CAF50 !important;
  font-weight: 500;
}

.custom_font_color_delete {
  color: #F44336 !important;
  font-weight: 500;
}

.chip-not-visited {
  background-color: #fce4e4 !important;
  border: 1px solid #d9534f !important;
}

.chip-pending {
  background-color: #fff9e6 !important;
  border: 1px solid #ffc107 !important;
}

.chip-visited {
  background-color: #e8f5e9 !important;
  border: 1px solid #4caf50 !important;
}
</style>